export class InsufficientRealTimeCourtroomCapacityError extends Error {
  constructor() {
    super('Insufficient RealTime STT courtroom limit configured to perform the current operation.')
    Object.setPrototypeOf(this, InsufficientRealTimeCourtroomCapacityError.prototype)
  }
}
